import React, { useMemo } from "react";
import css from './styles.module.scss';
import { VehiclesType } from "../../../../../../store/reducers/dashboard/vehicles/types/types";
import { Tooltip } from '@infobis/ui-styles-utils';
import cn from "classnames";
import BarsChart, { Item } from "@elements/barsChart/BarsChart";
import { VehicleStatus } from "../../../../../../store/reducers/dashboard/vehicles/statuses/types";
import { formatNumber2d } from "@utils/format/number";
import BaseChartTooltip from "@modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltip/BaseChartTooltip";
import {
	RowWithAreaFormatter
} from "@modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltip/rowFormatters/RowFormatters";

type ChartElementProps = {
	type: VehiclesType
}

const ChartElement = ({ type }: ChartElementProps) => {
	const { unitType, byUnitType: { count } } = type;

	const convertStatusToChartItem = (status: VehicleStatus): Item => {
		return { id: `${status.status}-${status.color}`, color: status.color, name: status.status, value: status.count }
	}

	const dataToRender: Item[] = useMemo(() => {
		return type.byUnitType.byStatus
			.map(convertStatusToChartItem)
			.sort((a, b) => a.name.localeCompare(b.name))
	}, [type])

	const getTooltipText = (point: Item) => {
		return (
			<BaseChartTooltip
				elements={[point].map(child => ({
					id: child.id,
					color: child.color,
					name: child.name,
					area: child.value,
					dimension: ''
				}))}
				cellsInRow={2}
				RowFormatter={RowWithAreaFormatter}
			/>
		)
	}

	const getTitleTooltipText = () => (
		<span>
			{unitType}
			<span className={css["row__item-count"]}> ({formatNumber2d(count)})</span>
		</span>
	)

	return (
		<div className={css["row"]}>
			<Tooltip.Flex text={getTitleTooltipText()}
						  tooltipProps={{ targetClass: cn(css['row__item'], css['row__item-name']), bodyClassName: css['row__item-body'] }}
			/>
			<BarsChart suppressTooltipStyles
					   tooltipProps={{ trigger: 'hover', position: 'top' }}
					   gap={2}
					   className={css['row__item']}
					   items={dataToRender}
					   height={14}
					   getTooltipText={getTooltipText} />
		</div>
	)
}

export default ChartElement;